import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const labels = {
  card: 'Tarjeta',
  fleet_save: 'Fleet Save',
  bank_transfer: 'Transferencia bancaria',
  sepa_15_day: 'SEPA quincenal',
  sepa_monthly: 'SEPA mensual',
};

const PaymentMethodDialog = ({ open, onOpenChange, methods, bankInfo, onSelect, loading }) => {
  const [selected, setSelected] = useState(methods[0] || 'card');

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Selecciona método de pago</DialogTitle>
        </DialogHeader>
        <div className="space-y-2 py-2">
          {methods.map((m) => (
            <label key={m} className="flex items-center gap-2 p-3 border rounded-lg cursor-pointer">
              <input
                type="radio"
                name="payment_method"
                checked={selected === m}
                onChange={() => setSelected(m)}
              />
              <span>{labels[m] || m}</span>
            </label>
          ))}
          {selected === 'bank_transfer' && bankInfo && (
            <div className="text-sm bg-gray-50 p-3 rounded border">
              <p><strong>{bankInfo.legal_name}</strong></p>
              <p>IBAN: {bankInfo.iban}</p>
              <p className="text-gray-600 mt-1">Referencia: número de factura</p>
            </div>
          )}
        </div>
        <Button
          className="w-full"
          disabled={loading || !selected}
          onClick={() => onSelect(selected)}
        >
          {loading ? 'Procesando...' : 'Continuar'}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentMethodDialog;
